const STORAGE_KEY = 'ticketzone.signup.requiresCaptcha';
const THIRTY_MINUTES = 30 * 60 * 1000;

export type SignupCaptchaPersisted = {
  requiresCaptcha: true;
  expiresAt: number;
};

export const readSignupCaptchaPersisted = (): SignupCaptchaPersisted | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as Record<string, unknown>;

    const isValid =
      parsed !== null && typeof parsed === 'object' && parsed.requiresCaptcha === true;
    if (!isValid) {
      return null;
    }

    const hasExpired = typeof parsed.expiresAt === 'number' && Date.now() > parsed.expiresAt;
    if (hasExpired) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    const expiresAt =
      typeof parsed.expiresAt === 'number' ? parsed.expiresAt : Date.now() + THIRTY_MINUTES;

    return { requiresCaptcha: true, expiresAt };
  } catch {
    return null;
  }
};

export const writeSignupCaptchaPersisted = (): void => {
  const payload: SignupCaptchaPersisted = {
    requiresCaptcha: true,
    expiresAt: Date.now() + THIRTY_MINUTES,
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const clearSignupCaptchaPersisted = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
